export const ADD_FLASH_MESSAGE = 'ADD_FLASH_MESSAGE';
export const DELETE_FLASH_MESSAGE = 'DELETE_FLASH_MESSAGE';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const ADD_DATA = 'ADD_DATA';



// WEBPACK FOOTER //
// ./client/actions/types.js